import { useSelector, useDispatch } from "react-redux";
import NavOptions from "../components/navOptions";
import { setActiveRoute } from "../reducers/activeRouteSlice";

const NavContainer = () => {
  const activeRoute = useSelector((state) => state.activeRoute);
  const dispatch = useDispatch();

  const handleSetActiveRoute = (route) => {
    dispatch(setActiveRoute(route));
  };

  return (
    <NavOptions
      activeRoute={activeRoute}
      setActiveRoute={handleSetActiveRoute}
    />
  );
};

export default NavContainer;
